import { render, staticRenderFns } from "./softwareIndex.vue?vue&type=template&id=d5dc78aa&scoped=true"
import script from "./softwareIndex.vue?vue&type=script&lang=js"
export * from "./softwareIndex.vue?vue&type=script&lang=js"
import style0 from "./softwareIndex.vue?vue&type=style&index=0&id=d5dc78aa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5dc78aa",
  null
  
)

export default component.exports